import { Component, Input, ViewChild, inject } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuService } from '../../menu.service';
import { WebdokuService } from '../../../web-doku/webdoku.service';
import { BookmarkService } from '../../../bookmarks/bookmark.service';
import { InfoService } from '../../../shared/services/info.service';
import { NavigationBaseComponent } from '../navigation-base/navigation-base.component';
import { HttpLoadingService } from '../../http-loading.service';
import { SettingsService } from '../../../shared/settings/settings.service';
import { UserInformationService } from '../../user-information.service';
import { LdwRouterService } from '../../../route/ldw-router.service';

@Component({
    selector: 'ldw-topbar-navigation',
    templateUrl: './topbar-navigation.component.html',
    styleUrls: ['./topbar-navigation.component.css'],
    standalone: false
})
export class TopbarNavigationComponent extends NavigationBaseComponent {
  menuService: MenuService;
  webDokuService: WebdokuService;
  bookmarkService: BookmarkService;
  infoService: InfoService;
  httpLoadingService: HttpLoadingService;
  settingsService: SettingsService;
  userInformationService: UserInformationService;
  private routerService = inject(LdwRouterService);

  @ViewChild('sidenav') sidenav!: MatSidenav;
  @Input() title = '';
  reason = '';

  constructor() {
    const menuService = inject(MenuService);
    const webDokuService = inject(WebdokuService);
    const bookmarkService = inject(BookmarkService);
    const infoService = inject(InfoService);
    const httpLoadingService = inject(HttpLoadingService);
    const settingsService = inject(SettingsService);
    const userInformationService = inject(UserInformationService);

    super(
      menuService,
      webDokuService,
      bookmarkService,
      infoService,
      httpLoadingService,
      settingsService,
      userInformationService
    );

    this.menuService = menuService;
    this.webDokuService = webDokuService;
    this.bookmarkService = bookmarkService;
    this.infoService = infoService;
    this.httpLoadingService = httpLoadingService;
    this.settingsService = settingsService;
    this.userInformationService = userInformationService;
  }

  close(reason: string) {
    this.reason = reason;
    this.sidenav.close();
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }

  navigateBack() {
    this.routerService.navigateBack();
  }
}
